<template>
	<div>
		<el-dialog title="投票表决" :visible.sync="voteDialogVisible" v-if="voteDialogVisible" :before-close="closeVote"
			width="800px" :close-on-click-modal="false" :close-on-press-escape="false">
			<div class="vote" v-loading="loading">
				<div class="" style="width: 100%;">
					<div class="flex align-center justify-center"
						style="background-color: rgba(38,101,255,0.05);width: 100%;padding: 20px 0px;border-radius: 5px;margin-bottom: 20px;">
						<div class="" style="width: 90%;">
							<div class="flex justify-between">
								<div class="vote-name_ml" style="width: 12%;">
									表决事项
								</div>
								<div class="vote-content_ml" style="width: 88%;">
									{{ voteInfo.name }}
								</div>
							</div>
							<div class="flex justify-between" style="margin-top: 14px;">
								<div class="vote-name_ml" style="width: 12%;">
									表决内容
								</div>
								<div class="vote-content_ml" style="width: 88%;">
									{{ voteInfo.content }}
								</div>
							</div>
						</div>
					</div>
				</div>

				<!-- <li class="vote-name">
						<h3>
							<i class="iconfont icon-shuxian"></i>
							<span>表决事项</span>
						</h3>
						<p>{{ voteInfo.name }}</p>
					</li>
					<li class="vote-name">
						<h3>
							<i class="iconfont icon-shuxian"></i>
							<span>表决内容</span>
						</h3>
						<p>{{ voteInfo.content }}</p>
					</li> -->

				<template v-if="status !== 0">
					<template v-if="userInfo.agent">
						<el-menu :default-active="'1'" class="menu" mode="horizontal" @select="handleSelect"
							active-text-color="#2766FF">
							<el-menu-item index="1">一起投票</el-menu-item>
							<el-menu-item index="2">分开投票</el-menu-item>
						</el-menu>
					</template>

					<div v-if="active === '2'">
						<div class="flex align-center justify-between" style="border-bottom: 1px solid #F0F0F0;">
							<div class="unfinished">
								<div class="flex align-center unfinished_li" style="">
									<div class="unfinished_title">
										未完成表决
									</div>
									<div class="unfinished_content" style="margin-left: 10px;">
										请选择表决人投票
									</div>
								</div>
								<div class="flex align-center justify-center unfinished_option" style=""
									v-for="item in voteList" v-if="!item.isVoted" :key="item.userId"
									@click="tapGathering(item)">
									{{ item.name }}
								</div>
							</div>
							<div class="unfinished" style="margin-left: 10px;">
								<div class="flex align-center unfinished_li" style="">
									<div class="unfinished_title">
										已完成表决
									</div>
									<div class="unfinished_content" style="margin-left: 10px;">
										<!-- 请选择表决人投票 -->
									</div>
								</div>
								<div class="flex align-center justify-center completed_option" style=""
									v-for="item in voteList" v-if="item.isVoted" :key="item.userId"
									@click="tapGathering(item)">
									{{ item.name }}
								</div>
							</div>
						</div>
						<div class="flex align-center justify-center reminder">
							请选择表决人投票
						</div>
						<!-- <ul class="vote-list">
							<li class="vote-li" @click="tapGathering(item)" :class="item.isVoted ? 'active' : ''"
								v-for="item in voteList" :key="item.userId">
								{{ item.name }}
							</li>
						</ul> -->
					</div>
					<template v-if="active === '1'">
						<template v-if="voteType === 'SINGLE_CHOICE'">
							<div class="" style="height: 350px;overflow-y: scroll;">
								<li v-for="(item, cindex) in groupingList" :key="item.groupId" class="vote-name">
									
									<h3>
										<!-- <div class="" v-for="(elm, i) in item.voteUsers" :key="i"
											style="font-size: 12px;font-family: Source Han Sans CN-Regular, Source Han Sans CN;font-weight: 400;color: #A6A6A6;line-height: 22px;">
											{{
										            elm
										    }}
											{{(item.voteUsers.length-1)>i?',':''}}
										</div> -->
										<!-- <i class="iconfont icon-shuxian"></i> -->
										<!-- 以前的方法 -->
										<!-- <span>
											<div class="flex">
												<div class="" style="margin-right: 10px;width: 15%;">
													{{ item.name }}
												</div>
												<div class="flex" style="width: 85%;flex-wrap: wrap;">
													<el-tag v-for="(elm, i) in item.voteUsers" type="info" :key="i"
														style="margin-right: 5px;margin-bottom: 5px;">{{
													                elm
													        }}</el-tag>
													
												</div>
												
												<el-tag v-if="!item.voteUsers.length && isAgent" type="info"
													:key="'i'" style="margin-right: 5px">该分组已投票完成</el-tag>
											</div>
										
										</span> -->
										<!-- <el-tag v-for="(elm, i) in item.groupPeople" type="info" :key="i"
											style="margin-right: 5px">{{
										                elm.userName
										        }}</el-tag> -->
										<div class="" style="width: 79%;display: flex;flex-wrap: wrap;">
										<span>{{ item.name }}
											<el-tag v-for="(elm, i) in item.voteUsers" type="info" :key="i"
												style="margin-right: 5px;margin-bottom: 5px;">{{
											                elm
											        }}</el-tag>
											<el-tag v-if="!item.voteUsers.length && isAgent" type="info" :key="'i'"
												style="margin-right: 5px">该分组已投票完成</el-tag>
										</span>
										</div>
										<!-- <span v-if="voteInfo.numerator!= 0"
											class="sign">(请选择{{ voteInfo.numerator }}个方案)</span> -->
									</h3>
									<ul class="vote-ul">
										<li class="vote-li" :class="citem.isFlag ? 'active' : ''"
											v-for="(citem, index) in item.options" :key="index"
											@click.stop="changeVote(index, cindex, item.groupPeople)">
											{{ citem.name }}
										</li>
										<!-- <div v-if="voteInfo.isReason && item.options[1].isFlag" class="">

										</div> -->
									</ul>
								</li>
							</div>


						</template>
						<template v-else>
							<li v-for="(item, i) in groupingList" :key="item.groupId" class="vote-name">
								<h3>
									<!-- <i class="iconfont icon-shuxian"></i> -->
									<div class="" style="width: 79%;display: flex;flex-wrap: wrap;">
									<span>{{ item.name }}
										<el-tag v-for="(elm, i) in item.voteUsers" type="info" :key="i"
											style="margin-right: 5px;margin-bottom: 5px;">{{
										                elm
										        }}</el-tag>
										<el-tag v-if="!item.voteUsers.length && isAgent" type="info" :key="'i'"
											style="margin-right: 5px">该分组已投票完成</el-tag>
									</span>
									</div>
									<span v-if="voteInfo.numerator!= 0"
										class="sign">(请选择{{ voteInfo.numerator }}个方案)</span>
								</h3>
								<ul class="vote-ul">

									<li v-if="citem.isShow && voteType == 'ELECT'" class="vote-li"
										:class="citem.isFlag ? 'active' : ''" v-for="(citem, index) in item.options"
										:key="index" @click.stop="changeCandidate(citem, i, item.groupPeople)">
										{{ citem.name }}
									</li>
									<li v-if="voteType != 'ELECT'" class="vote-li" :class="citem.isFlag ? 'active' : ''"
										v-for="(citem, index) in item.options" :key="index"
										@click.stop="changeCandidate(citem, i, item.groupPeople)">
										{{ citem.name }}
									</li>
								</ul>
								<div v-if="voteType=='ELECT' && voteInfo.enableRecommend" class="">
									<div class="" style="display: flex;align-items: center;position: relative;">
										<div class="" style="font-size: 16px;color: #606266;font-weight: 600;">
											我要推荐
										</div>

										<el-button plain v-if="voteText === '立即表决'"
											@click="dialogVisibleShow(i,!item.groupPeople.length)"
											style="margin-left: 15px;" class="button-new-tag buttonnoen" size="small">+
											添加推荐人
										</el-button>
										<div v-if="dialogVisible[i].type" class=""
											style="position: absolute;top: -200px;border: 1px solid #CCCCCC;background-color: #FFFFFF;border-radius: 5px;margin-top: 10px;padding: 10px;left: -252px;width: 210px;">
											<div class=""
												style="display: flex;justify-content: space-between;margin-bottom: 5px;">
												<div class="">
													可推荐1人
												</div>
												<i @click="dialogVisibleClose(i)" class="el-icon-close"
													style="font-size: 18px;"></i>
											</div>
											<div class=""
												style="border-bottom: 2px solid #2766ff;margin-bottom: 10px;padding-bottom: 10px;">
												<el-input v-model="keyword" placeholder="请输入搜索关键字"
													prefix-icon="el-icon-search">
												</el-input>
											</div>
											<div class="" style="width: 100%;height: 350px;overflow-y: auto;">
												<div v-if="keyword==''||item.name.includes(keyword)"
													@click="selectCreatorUserList(item,i)" class=""
													v-for="item in creatorUserLists">
													<el-button
														style="width: 190px;overflow:hidden;white-space: nowrap;text-overflow: ellipsis;-o-text-overflow:ellipsis;text-align: left;"
														type="text">{{item.name}}</el-button>
												</div>
											</div>
										</div>
									</div>
									<div class="" style="display: flex;flex-flow: wrap;margin: 15px 20px;">
										<div class="" v-for="(item,index) in selectList[i]"
											style="border: 1px solid #E5E5E5;margin-right: 20px;display: flex;align-items: center;border-radius: 3px;padding: 5px 20px;margin-bottom: 15px;color: #74798C;line-height: 20px;font-size: 14px;">
											<div class="">
												{{item.name}}
											</div>
											<div v-if="voteText === '立即表决'" class="" style="margin-left: 10px;">
												<i @click="deleteSelectList(index,i)" class="el-icon-close"
													style="font-size: 14px;"></i>
											</div>
										</div>
									</div>
								</div>
							</li>

						</template>
					</template>
				</template>
				<template v-else>
					<div style="overflow-y: scroll;height: 400px;">
						<div class="" style="border-left:6px solid #F29700;margin: 20px 0px;">
							<div class=""
								style="font-size: 14px;font-family: Source Han Sans CN-Medium, Source Han Sans CN;font-weight: bold;color: #282D30;line-height: 20px;margin-left: 10px;">
								未投票
							</div>
						</div>
						<!-- <el-divider content-position="left"></el-divider> -->
						<el-table :data="table.no_vote" style="width: 100%">
							<el-table-column prop="name" label="姓名" width="180" align="center">
							</el-table-column>
							<el-table-column prop="idNumber" label="证件号" width="180" align="center">
							</el-table-column>
							<el-table-column label="投票信息" align="center">
								<template slot-scope="scope">
									<div v-for="(elm, i) in scope.row.voteRecord4Vos_f" :key="i">
										{{ elm }}
									</div>
								</template>
							</el-table-column>
						</el-table>
						<div class="" style="border-left:6px solid #009944;margin: 20px 0px;">
							<div class=""
								style="font-size: 14px;font-family: Source Han Sans CN-Medium, Source Han Sans CN;font-weight: bold;color: #282D30;line-height: 20px;margin-left: 10px;">
								已投票
							</div>
						</div>
						<!-- <el-divider content-position="left">已投票</el-divider> -->
						<el-table :data="table.voted" style="width: 100%">
							<el-table-column prop="name" label="姓名" width="180" align="center">
							</el-table-column>
							<el-table-column prop="idNumber" label="证件号" width="180" align="center">
							</el-table-column>
							<el-table-column label="投票信息" align="center">
								<template slot-scope="scope">
									<div v-for="(elm, i) in scope.row.voteRecord4Vos_f" :key="i">
										{{ elm }}
									</div>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</template>
			</div>
			<div class="btn" v-if="active !== '2'">
				<!-- {{disabled}}{{isVote}}{{isDisabledButton}} -->
				<el-button style="width: 120px;" v-if="disabled || isVote" type="text" :loading="btnLoading"
					@click="immediateVote" :disabled="(disabled || isVote)">{{ voteText }}
				</el-button>
				<el-button style="width: 120px;" v-else type="primary"
					:class="(disabled || isVote || isDisabledButton) ? 'disabled' : ''" :loading="btnLoading"
					@click="immediateVote" :disabled="(disabled || isVote || isDisabledButton)">{{ voteText }}
				</el-button>
				<!-- {{disabled}}{{isVote}}{{isDisabledButton}} -->
			</div>
		</el-dialog>
		<el-dialog title="反对理由" :visible.sync="objectionDialogVisible" width="30%" top="10%"
			:close-on-click-modal="false" :close-on-press-escape="false">
			<div v-if="remarkList.length>0" class="" style="width: 100%;">
				<el-input type="textarea" :rows="6" :placeholder="`请输入反对理由，字数不少于${voteInfo.reasonWordNum}字`"
					v-model="remark" :disabled="objectionAstrict">
				</el-input>
				<div class="flex align-center justify-end" style="margin-top: 10px;">
					已输入{{remark.length}}字，不少于{{voteInfo.reasonWordNum}}字
				</div>
			</div>
			<span v-if="!objectionAstrict" slot="footer" class="dialog-footer">
				<el-button @click="objectionDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="submitObjection">确 定</el-button>
			</span>
		</el-dialog>
		<SeparateVote v-if="!!separateVoteData.userId" :voteDialogVisible="!!separateVoteData.userId"
			:userData="separateVoteData" @close="separateVoteData = {}" @finish="separateVoteByFinish"
			:status="status" />
	</div>
</template>

<script>
	let userId = JSON.parse(window.sessionStorage.getItem('ms_userInfo')).id;
	import {
		mapState
	} from 'vuex';
	import {
		getVoteDetail,
		getUserGrouping,
		voteByBallot,
		voteByBallotAll,
		voteByBallotVoteId,
		getVotingRecords,
		getVotingRecordsVoteId,
		getVotingRecordsMeetingId
	} from '@/serve/userGrouping';
	import {
		getUserSign,
	} from '@/serve/sign';
	import SeparateVote from './separateVote.vue';
	export default {
		components: {
			SeparateVote
		},
		props: {
			voteId: String,
			meetingId: String,
			voteDialogVisible: Boolean,
			status: Number,
		},
		async created() {
			// this.voteId = this.$route.query.id;
			// this.meetingId = this.$route.query.meetingId;
			// if (this.status === 1) {
			//     this.voteText = '已完成表决'
			//     this.disabled = true
			// } else if (this.status === 0) {
			//     this.voteText = '表决已结束'
			//     this.disabled = true
			// }
			await getUserSign(this.meetingId)
				.then((res) => {
					this.userInfo = res
				});
			console.log("userInfo", this.userInfo)
			this.isAgent = this.userInfo.agent;
			console.log("this.isAgent", this.isAgent)
			console.log("status", this.status)
			if(this.userInfo.agent){
				await voteByBallotVoteId({
					voteId: this.voteId
				}).then((res) => {
					console.log("res:", res)
					this.voteList = res
				});
			}
			if (this.status === 0) {
				this.getVoteDetail();
				getVotingRecordsVoteId({
					voteId: this.voteId,
					meetingId: this.meetingId,
					userId,
				}).then(res => {
					const handleTable = (arr) => arr.map(group => {
						group.voteRecord4Vos_f = group.voteRecord4Vos.map(item =>
							`${item.groupName}：${item.optionList.join(',')}`)
						return group
					})
					this.table = {
						no_vote: handleTable(res.no_vote),
						voted: handleTable(res.voted),
					};
				})
			} else {
				this.getVotingRecords();
			}
			if (this.status === 1) {
				console.log("status", this.status)
				this.finishVote();
			}
		},
		data() {
			return {
				isVoteRecord: false,
				isVote: false,
				voteText: '立即表决',
				btnLoading: false,
				loading: false,
				currentId: '',
				voteInfo: {},
				groupingList: [],
				ids: [],
				voteRecords: {},
				isWaiver: false,
				allowPartVote: false, //是否允许分组投票
				synchronizationVote: [], // 同步表决
				groupVoteRecordList: [],
				voteType: '', // 选项类型
				voteList: [],
				active: '1',
				separateVoteData: {},
				disabled: false,
				table: {},
				dialogVisible: [],
				keyword: '',
				creatorUserList: [],
				creatorUserLists: [],
				selectList: [],
				userInfo: {},
				objectionDialogVisible: false,
				remarkIndex: 0,
				remarkList: [],
				remark: '',
				objectionAstrict: false,
			};
		},
		computed: {
			// ...mapState({
			// 	userInfo: (state) => state.user.userInfo
			// }),
			// disabled() {
			//     if (this.voteType === 'SINGLE_CHOICE') {
			//         return this.groupVoteRecordList.length !== this.groupingList.length;
			//     }
			//     return false
			// },
			isDisabledButton() {
				if (this.voteInfo.voteType === 'MULTIPLE_CHOICE' || this.voteInfo.voteType === 'ELECT') {
					return this.groupingList.some(group => {
						let count = 0;
						// if (!group.groupPeople.length) {
						// 	return false
						// }
						(group.options || []).some(item => {
							if (item.name === "弃权" && item.isFlag) {
								count = this.voteInfo.numerator;
							} else if (item.isFlag) {
								count++;
							}
						})
						return count !== this.voteInfo.numerator
					})
				} else {
					console.log("groupingList", this.groupingList)
					return !this.groupingList.every(group => (group.options || []).some(item => item.isFlag))
					// return !this.groupingList.every(group => !group.groupPeople.length || (group.options || []).some(
					// 	item =>
					// 	item.isFlag))
				}
			},

		},
		methods: {
			submitObjection() {
				console.log("remarkList", this.remarkList);
				if (this.remark == '') {
					this.$message({
						message: `请输入反对理由，字数不少于${this.voteInfo.reasonWordNum}字`,
						type: 'error'
					});
					return
				} else if (this.remark.length < this.voteInfo.reasonWordNum) {
					this.$message({
						message: `字数不少于${this.voteInfo.reasonWordNum}字`,
						type: 'error'
					});
					return
				}
				if (this.allowPartVote) {
					this.remarkList[this.remarkIndex].name = this.remark;
				} else {
					this.remarkList[0].name = this.remark;
				}
				this.objectionDialogVisible = false;
				this.objectionAstrict = false;
			},
			dialogVisibleShow(index, groupPeopleType) {
				if (this.groupingList[index].isWaiver) {
					return this.$message('当前您已选择弃权，若要添加推荐人，请点击取消弃权!');
				}
				if (groupPeopleType && this.isAgent) {
					this.$message({
						message: '分组已投票完成，请选择其他分组投票！',
						type: 'warning'
					});
					return
				}
				this.dialogVisible[index].type = !this.dialogVisible[index].type;
				for (let i in this.dialogVisible) {
					if (index != i) {
						this.dialogVisible[i].type = false;
					}
				}
				console.log("selectList", this.selectList)
				this.creatorUserListInit(index);
				console.log("dialogVisible", this.dialogVisible)
			},
			deleteSelectList(index, i) {
				this.selectList[i].splice(index, 1);
				this.filteredArray(i);
			},
			dialogVisibleClose(index) {
				this.keyword = '';
				this.dialogVisible[index].type = false;
			},
			selectCreatorUserList(item, index) {
				if (this.selectList[index].length == 0) {
					this.selectList[index].push(item);
					this.filteredArray(index);
				} else {
					this.$message.error('推荐人已满');
				}
			},
			creatorUserListInit(index) {
				let list = [];
				console.log("voteInfo", this.voteInfo)
				for (let i in this.voteInfo.options) {
					if (!this.voteInfo.options[i].isShow) {
						list.push(this.voteInfo.options[i])
					}
				}
				let lists = [];
				for (let i in this.voteInfo.groups) {
					lists.push(list);
				}
				this.creatorUserList = lists;
				console.log("creatorUserList", lists);
				this.filteredArray(index);
			},
			filteredArray(index) {
				this.creatorUserLists = this.creatorUserList[index].filter(itemA => {
					return !this.selectList[index].some(itemB => itemB.name === itemA.name)
				})
			},
			separateVoteByFinish() {
				this.getVotingRecords();
				this.handleSelect('2')
				this.separateVoteData = {}
			},
			tapGathering(item) {
				this.separateVoteData = {
					...item,
					meetingId: this.meetingId,
					voteId: this.voteId
				};
			},
			handleSelect(val) {
				this.active = val;
				if (val === '2') {
					voteByBallotVoteId({
						voteId: this.voteId
					}).then((res) => {
						console.log("res:", res)
						this.voteList = res
					});
				} else {
					this.disabled = true;
					this.isVote = false;
					this.voteText = '立即表决';
					this.selectList = [];
					this.isVoteRecord = false;
					voteByBallotVoteId({
						voteId: this.voteId
					}).then((res) => {
						console.log("res:", res)
						this.voteList = res
					});
					this.getVotingRecords();
				}
			},
			finishVote() {
				this.btnLoading = false;
				this.voteText = '已完成表决';
				this.isVote = true;
			},
			// 获取用户在当前会议下的投票记录
			async getVotingRecords() {
				const res = await getVotingRecords({
					meeting_id: this.meetingId,
					user_id: this.userInfo.userId,
				})
				const resAll = this.userInfo.agent ? await getVotingRecordsMeetingId({
					meetingId: this.meetingId
				}) : {}
				this.voteRecords = res;
				this.voteRecordsAll = resAll;
				this.getVoteDetail();
			},
			// 同步表决
			syncVote() {
				let synchronizationVote = window.localStorage.getItem('synchronizationVote');
				if (synchronizationVote) {
					synchronizationVote = JSON.parse(synchronizationVote);
					synchronizationVote.push(this.voteId);
					window.localStorage.setItem('synchronizationVote', JSON.stringify(synchronizationVote));
				} else {
					this.synchronizationVote.push(this.voteId);
					window.localStorage.setItem('synchronizationVote', JSON.stringify(this.synchronizationVote));
				}
			},
			// 立即表决
			immediateVote() {
				if (this.isDisabledButton) {
					return
				}
				this.$confirm('投票一旦提交不可更改, 请确认是否提交?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					customClass: 'del-model',
					type: 'warning'
				}).then(() => {
					this.btnLoading = true;

					// 如果是代理人
					if (this.userInfo.agent) {
						console.log("active", this.active)
						if (this.active === '1') {
							let groupVoteRecordList = []

							if (this.voteType === 'MULTIPLE_CHOICE' || this.voteType === 'ELECT') {
								let selectList = JSON.parse(JSON.stringify(this.selectList));
								let voteInfo = JSON.parse(JSON.stringify(this.voteInfo));
								console.log("voteInfo.groups[i]", voteInfo.groups)
								if (this.voteType === 'ELECT') {
									for (let i = 0; i < voteInfo.groups.length; i++) {
										if (voteInfo.groups[i].options) {
											for (let j = 0; j < voteInfo.groups[i].options.length; j++) {
												if (selectList[i][0] != undefined) {
													if (voteInfo.groups[i].options[j].id == selectList[i][0].id) {
														voteInfo.groups[i].options[j].isFlag = true;
													}
												} else {
													if (voteInfo.enableRecommend) {
														if (voteInfo.groups[i].options[0].isFlag && voteInfo
															.groups[i]
															.options[0].name == '弃权') {
															if (voteInfo.groups[i].groupPeople.length != 0) {
																if (!voteInfo.groups[i].options[0].isFlag &&
																	selectList[i]
																	.length == 0) {
																	this.$message.error("请选择推荐人");
																	this.btnLoading = false;
																	return
																}
															}

														} else {
															if (voteInfo.groups[i].groupPeople.length != 0) {
																if (selectList[i].length == 0) {
																	this.$message.error("请选择推荐人");
																	this.btnLoading = false;
																	return
																}
															}
														}
													}

												}
											}
										}
									}
								}
								groupVoteRecordList = (voteInfo.groups || []).map(item => ({
									groupId: item.groupId,
									voteId: this.voteId,
									optionIds: (item.options || []).filter(elm => elm.isFlag).map(cc =>
										cc.id),
									voteWay: 'SELF'
								})).filter(item => item.optionIds.length)
							} else {
								groupVoteRecordList = this.groupVoteRecordList.map(item => ({
									...item,
									voteWay: 'SELF'
								}))
								let list = [];
								for (let j = 0; j < this.voteInfo.groups.length; j++) {
									if (this.voteInfo.groups[j].options != undefined) {
										list.push(this.voteInfo.groups[j]);
									}
								}
								console.log("voteInfo", this.voteInfo)
								console.log("groupVoteRecordList", this.groupVoteRecordList)
								if (this.voteInfo.isReason) {
									if (this.allowPartVote) {
										for (let i = 0; i < this.remarkList.length; i++) {
											if (this.remarkList[i].name == '' && this.remarkList[i].id == '反对') {
												this.$message.error(`请填写“${list[i].name}”反对理由`);
												this.btnLoading = false;
												return
											}
										}
										for (let i = 0; i < groupVoteRecordList.length; i++) {
											if (this.remarkList[i].id == '反对') {
												groupVoteRecordList[i].remark = this.remarkList[i].name;
											}

										}
									} else {
										if (this.remarkList[0].name == '' && this.remarkList[0].id == '反对') {
											this.$message.error(`请填写反对理由`);
											this.btnLoading = false;
											return
										}
										if (this.remarkList[0].id == '反对') {
											for (let i = 0; i < groupVoteRecordList.length; i++) {
												groupVoteRecordList[i].remark = this.remarkList[0].name;
											}
										}
									}
								}
								console.log("groupVoteRecordList", groupVoteRecordList)
								// groupVoteRecordList = this.groupVoteRecordList.map(item => ({
								// 	...item,
								// 	voteWay: 'AGENT_ALL'
								// }))
							}
							console.log("groupVoteRecordList", groupVoteRecordList)
							// return
							// 一起投票
							voteByBallotAll({
									groupVoteRecordList,
									voteId: this.voteId,
									creditorId: this.userInfo.userId,
								})
								.then(() => {
									this.$message.success('表决成功');
									this.finishVote();
									this.syncVote();
									this.btnLoading = false;
									this.closeVote()
								})
								.catch((err) => {
									if (!err.data.success) {
										this.$message.error(err.data.message || '系统异常');
									}
									this.btnLoading = false;
								});
						}
						return;
					}
					console.log("voteType", this.voteType)
					if (this.voteType === 'SINGLE_CHOICE') {
						let groupVoteRecordList = this.groupVoteRecordList.map(item => ({
							...item,
							voteWay: 'SELF'
						}))
						let list = [];
						for (let j = 0; j < this.voteInfo.groups.length; j++) {
							if (this.voteInfo.groups[j].options != undefined) {
								list.push(this.voteInfo.groups[j]);
							}
						}
						console.log("voteInfo", this.voteInfo)
						console.log("groupVoteRecordList", this.groupVoteRecordList)
						if (this.voteInfo.isReason) {
							if (this.allowPartVote) {
								for (let i = 0; i < this.remarkList.length; i++) {
									if (this.remarkList[i].name == '' && this.remarkList[i].id == '反对') {
										this.$message.error(`请填写“${list[i].name}”反对理由`);
										this.btnLoading = false;
										return
									}
								}
								for (let i = 0; i < groupVoteRecordList.length; i++) {
									if (this.remarkList[i].id == '反对') {
										groupVoteRecordList[i].remark = this.remarkList[i].name;
									}

								}
							} else {
								if (this.remarkList[0].name == '' && this.remarkList[0].id == '反对') {
									this.$message.error(`请填写反对理由`);
									this.btnLoading = false;
									return
								}
								if (this.remarkList[0].id == '反对') {
									for (let i = 0; i < groupVoteRecordList.length; i++) {
										groupVoteRecordList[i].remark = this.remarkList[0].name;
									}
								}
							}
						}
						console.log("groupVoteRecordList", groupVoteRecordList)
						// return 
						voteByBallot({
								groupVoteRecordList: groupVoteRecordList,
								voteId: this.voteId,
								creditorId: this.userInfo.userId,
							})
							.then(() => {
								this.$message.success('表决成功');
								this.finishVote();
								this.syncVote();
								this.closeVote()
							})
							.catch((err) => {
								if (err.status === 400 && !err.data.success) {
									this.$message.error(err.data.message);
									this.finishVote();
								}
							});
					} else {
						let selectList = JSON.parse(JSON.stringify(this.selectList));
						let voteInfo = JSON.parse(JSON.stringify(this.voteInfo));
						console.log("this.voteInfo", this.voteInfo)
						if (this.voteType === 'ELECT') {
							let list = [];
							for (let i = 0; i < voteInfo.groups.length; i++) {
								if (voteInfo.groups[i].options != undefined) {
									list.push(voteInfo.groups[i]);
								}
							}
							voteInfo.groups = list;
							for (let i = 0; i < voteInfo.groups.length; i++) {
								if (voteInfo.groups[i].options != undefined) {
									for (let j = 0; j < voteInfo.groups[i].options.length; j++) {
										if (selectList[i][0] != undefined) {
											if (voteInfo.groups[i].options[j].id == selectList[i][0].id) {
												voteInfo.groups[i].options[j].isFlag = true;
											}
										} else {
											if (voteInfo.enableRecommend) {
												if (voteInfo.groups[i].options[0].isFlag && voteInfo.groups[i]
													.options[0].name == '弃权') {
													if (!voteInfo.groups[i].options[0].isFlag && selectList[i]
														.length == 0) {
														this.$message.error("请选择推荐人");
														this.btnLoading = false;
														return
													}
												} else {
													if (selectList[i].length == 0) {
														this.$message.error("请选择推荐人");
														this.btnLoading = false;
														return
													}
												}
											}

										}
									}
								}
							}
						}
						const groupVoteRecordList = (voteInfo.groups || []).map(item => ({
							groupId: item.groupId,
							voteId: this.voteId,
							optionIds: (item.options || []).filter(elm => elm.isFlag).map(cc => cc.id),
							voteWay: 'SELF'
						})).filter(item => item.optionIds.length)
						console.log("groupVoteRecordList", groupVoteRecordList)
						// return
						voteByBallot({
								groupVoteRecordList,
								voteId: this.voteId,
								creditorId: this.userInfo.userId,
							})
							.then(() => {
								this.$message.success('表决成功');
								this.finishVote();
								this.syncVote();
								this.closeVote()
							})
							.catch((err) => {
								if (err.status === 400 && !err.data.success) {
									this.$message.error(err.data.message);
									this.btnLoading = false;
									// this.finishVote();
								}
							});
					}
				});
			},
			// 选择代表
			changeCandidate(item, index, userList) {
				console.log("item", item)
				console.log("this.isAgent", this.isAgent)
				console.log("this.isVote", this.isVote)
				if (!userList.length && this.isAgent) {
					this.$message({
						message: '分组已投票完成，请选择其他分组投票！',
						type: 'warning'
					});
					return
				}
				if (this.disabled || this.isVote) {
					this.$message({
						message: '该分组已分开投票，请分开投票!',
						type: 'warning'
					});
					return
				}
				const obj = this.groupingList[index]
				if (item.name === '弃权') {
					item.isFlag = !item.isFlag;
					if (item.isFlag) {
						for (let i = 0; i < obj.options.length; i++) {
							let ktem = obj.options[i];
							if (item.id === ktem.id) {
								ktem.isFlag = true;
							} else {
								ktem.isFlag = false;
							}
						}
						obj.isWaiver = true;
						this.selectList[index] = [];
						this.dialogVisible[index].type = false;
						this.$message('您已选择弃权');
						return;
					} else {
						obj.isWaiver = false;
						return
					}
				}
				if (obj.isWaiver) {
					return this.$message('当前您已选择弃权，若重新选择，请点击取消弃权!');
				}
				// 判断数量
				let count = 0;
				obj.options.forEach(item => {
					if (item.isFlag) {
						count++
					}
				})
				// 取消选中
				if (item.isFlag) {
					item.isFlag = false;
					obj.isWaiver = false;
					return;
				}
				// 添加选中
				if (count < this.voteInfo.numerator) {
					item.isFlag = true;
				} else {
					// 重复 - 提示弹窗
					this.$message(`当前已有${this.voteInfo.numerator}个方案`);
				}
				obj.isWaiver = false;
			},
			// 选票（同意&反对）
			changeVote(index, cindex, userList) {

				if (!userList.length && this.isAgent) {
					this.$message({
						message: '分组已投票完成，请选择其他分组投票！',
						type: 'warning'
					});
					return
				}
				// if (this.disabled || this.isVote) {
				// 	this.$message({
				// 		message: '该分组已分开投票，请分开投票!',
				// 		type: 'warning'
				// 	});
				// 	return
				// }
				if (this.isVoteRecord) {
					console.log("groupVoteRecordList", this.groupVoteRecordList)
					console.log("remarkList", this.remarkList)
					if (this.remarkList[cindex].id == '反对') {
						this.remark = this.remarkList[cindex].name;
						this.objectionAstrict = true;
						this.objectionDialogVisible = true;
					}
					return;
				}
				console.log("voteInfo", this.voteInfo)
				if (this.allowPartVote) {
					let listItem = this.groupingList[cindex];
					listItem.options.forEach((item) => {
						item.isFlag = false;
					});
					listItem.options[index].isFlag = true;
					this.groupVoteRecordList = this.groupVoteRecordList.filter((item) => item.groupId !== listItem
						.groupId);

					listItem.options.forEach((item) => {
						if (item.isFlag) {
							this.groupVoteRecordList.push({
								groupId: listItem.groupId,
								voteId: item.voteId,
								optionIds: [item.id],
								remark: '',
							});
						}

					});

					if (listItem.options[index].isFlag && listItem.options[index].name == '反对' && this.voteInfo.isReason) {
						this.remark = '';
						if (this.remarkList[cindex].name != '') {
							this.remark = this.remarkList[cindex].name
						}
						this.remarkList[cindex].id = '反对';
						this.objectionDialogVisible = true;
						this.remarkIndex = cindex;
					} else if (listItem.options[index].isFlag && listItem.options[index].name == '同意') {
						this.remarkList[cindex].id = '';
						this.remarkList[cindex].name = '';
					}
				} else {
					this.groupVoteRecordList = [];
					this.groupingList.forEach((item, indexs) => {
						item.options.forEach((citem, cindex) => {
							citem.isFlag = false;
							if (cindex === index) {
								// if(item.groupPeople !== undefined && item.groupPeople !==null && item.groupPeople.length > 0){
								// 	citem.isFlag = true;
								// }else{
								// 	citem.isFlag = false;
								// }
								console.log("Object.prototype.toString.call(item.groupPeople)", Object
									.prototype.toString.call(item.groupPeople))
								if (!item.groupPeople.length && this.isAgent) {
									citem.isFlag = false;
								} else {
									citem.isFlag = true;
								}
								// if(item.groupPeople.length === "0"){
								// 	citem.isFlag = false;
								// }else{
								// 	citem.isFlag = true;
								// }
								this.groupVoteRecordList.push({
									groupId: item.groupId,
									voteId: item.voteId,
									optionIds: [citem.id],
									remark: '',
								});
								if (this.voteInfo.isReason && citem.isFlag && citem.name == '反对') {
									this.remark = '';
									if (this.remarkList[indexs].name != '') {
										this.remark = this.remarkList[indexs].name
									}
									this.remarkList[indexs].id = '反对';
									this.objectionDialogVisible = true;
									this.remarkIndex = indexs;
								} else if (citem.isFlag && citem.name == '同意') {
									this.remarkList[indexs].id = '';
									this.remarkList[indexs].name = '';
								}
							} else {
								citem.isFlag = false;
							}
						});
					});

				}
			},
			// 获取详情
			getVoteDetail() {
				this.loading = true;
				console.log("this.voteId", this.voteId)
				getVoteDetail(this.voteId)
					.then((res) => {
						console.log("表决详情：", res)
						this.voteInfo = res;
						this.voteType = res.voteType;
						this.allowPartVote = res.allowPartVote; // 是否允许分组投票
						this.voteInfo.options.forEach((item) => {
							this.$set(item, 'isFlag', false);
						});
						if (this.voteInfo.voteType == 'ELECT') {
							for (let i in this.voteInfo.groups) {
								this.dialogVisible.push({
									type: false
								})
								this.selectList.push([])
							}
						}

						this.getUserGrouping();

						// for (let i in res.groups[0].options) {
						// 	if (res.groups[0].options[i].isFlag) {
						// 		console.log("ss", res.groups[0].options[i])
						// 	}
						// }
						console.log("res", res)
					})
					.catch((err) => {
						this.loading = false;
						this.$message.error(err.data.message);
					});
			},
			// 获取当前用户所属组别
			getUserGrouping() {
				console.log("this.meetingId", this.meetingId)
				this.groupingList = [];
				getUserGrouping(this.meetingId, userId)
					.then((res) => {
						this.loading = false;
						this.disabled = false;
						// 当前用户存在的组别进行筛选
						let arr = res.map((item) => item.groupId);
						this.groupingList = this.voteInfo.groups.filter((item) => arr.indexOf(item.groupId) > -1);
						this.groupingList = this.groupingList.map((item) => {
							const users = res.filter((elm) => elm.groupId === item.groupId);
							item.groupPeople = users.filter(elm => {
								const hasUser = (this.voteRecords[this.voteInfo.id] || []).some(cc => {
									return cc.creditorId === elm.userId && (cc.voteWay ===
										'AGENT_SPLIT' || cc.voteWay === 'SELF')
								})
								return !hasUser && !!elm.userName
							});
							return item;
						});
						console.log("voteRecords", this.voteRecords)
						console.log("this.voteInfo.id", this.voteInfo.id)
						console.log("this.voteInfo.groups", this.voteInfo.groups)
						console.log("groupingList", this.groupingList)
						console.log("res++++", res)
						this.groupingList.forEach((item) => {
							this.$set(item, 'options', JSON.parse(JSON.stringify(this.voteInfo.options)));
						});
						const chooseList = this.voteRecords[this.voteInfo.id] || [];

						let voteUserList = res.map((item) => {
							return {
								userName: item.userName,
								groupId: item.groupId,
								userId: item.userId
							};
						}).filter(item => {
							return !chooseList.some(elm => elm.creditorId === item.userId && elm.voteWay !==
								'AGENT_ALL')
						});
						let list = [];
						console.log("voteList", this.voteList)
						for (let i = 0; i < voteUserList.length; i++) {
							voteUserList[i]
							for (let j = 0; j < this.voteList.length; j++) {
								if (this.voteList[j].userId == voteUserList[i].userId && !this.voteList[j].isVoted) {
									list.push(voteUserList[i])
								}

							}
						}
						console.log("list", list);
						voteUserList = list;
						console.log("voteUserList", voteUserList)
						this.groupingList.forEach((item) => {
							// 每一组别分别执行以下操作：
							let voteUsers = [];
							voteUserList.forEach((eachV) => {
								if (item.groupId == eachV.groupId) {
									voteUsers.push(eachV
									.userName); //根据groupId,将voteUserList的用户匹配添加到同一组别下
								}
							});
							this.$set(item, "voteUsers", voteUsers);
							// vue中需要使用 this.$set 将新增属性渲染到DOM上.
							// 将voteinfo中的options 合并到了 groupList
							this.$set(
								item,
								"options",
								JSON.parse(JSON.stringify(this.voteInfo.options))
							);
						});


						if (this.voteRecords[this.voteInfo.id]) {
							// 几选几
							if (this.voteInfo.voteType === 'MULTIPLE_CHOICE' || this.voteInfo.voteType === 'ELECT') {
								let isFinish = false;
								console.log("this.voteRecords[this.voteInfo.id]", this.voteRecords[this.voteInfo.id])
								this.groupingList.forEach(group => {
									group.options.forEach((item) => {

										this.voteRecords[this.voteInfo.id].forEach(elm => {
											if (
												elm.groupId === group.groupId &&
												((this.userInfo.attend && elm
														.voteWay === 'AGENT_SPLIT') || (this
														.userInfo.attend && elm
														.voteWay === 'SELF') || elm.voteWay ===
													'AGENT_ALL')) {
												elm.optionIds.forEach(
													(id) => {
														if (id === item.id) {
															console.log("id", id)
															isFinish = true
															item.isFlag = true;
														}
													}
												);
											}
										})
									});
								})
								// this.selectList = [];
								console.log("groupingList", this.groupingList)
								if (this.voteInfo.voteType === 'ELECT' && (this.isVote || this.isDisabledButton)) {
									for (let i in this.groupingList) {
										this.selectList.push([]);
										console.log("i", i)
										for (let z in this.groupingList[i].options) {

											if (!this.groupingList[i].options[z].isShow && this.groupingList[i]
												.options[z].isFlag) {

												this.selectList[i].push(this.groupingList[i].options[z]);
											}
										}

									}
								}
								console.log("selectList", this.selectList)
								if (isFinish) {
									this.finishVote();
								} else {
									this.finishVotes();
								}
							} else if (this.voteInfo.voteType === 'SINGLE_CHOICE') {
								// 同意&反对
								let isFinish = false
								this.groupingList.forEach(item => {
									this.voteRecords[this.voteInfo.id].forEach(citem => {
										if (item.groupId === citem.groupId && (
												(this.userInfo.attend && citem.voteWay ===
													'AGENT_SPLIT') ||
												(this.userInfo.attend && citem.voteWay ===
													'SELF') ||
												citem.voteWay === 'AGENT_ALL'
											)) {
											item.options.forEach(vitem => {
												if (citem.optionIds[0] === vitem.id) {
													vitem.isFlag = true;
													isFinish = true
												}
											});
											if (citem.remark != '' && item.remark == undefined) {
												item.remark = citem.remark
											}
										}
									});
								});
								if (isFinish) {
									this.isVoteRecord = true;
									this.finishVote();
								} else {
									this.finishVotes();
								}
								for (let i = 0; i < this.groupingList.length; i++) {
									if (this.groupingList[i].remark != undefined) {
										this.remarkList.push({
											id: '反对',
											name: this.groupingList[i].remark
										})
									} else {
										this.remarkList.push({
											id: '',
											name: ''
										})
									}
								}
								console.log("remarkList", this.remarkList)
								console.log("groupingList", this.groupingList)
								console.log("voteRecords", this.voteRecords[this.voteInfo.id])
							} else {
								// 同意&反对
								let isFinish = false
								this.groupingList.forEach((item) => {
									this.voteRecords[this.voteInfo.id].forEach((citem) => {
										if (item.groupId === citem.groupId) {
											item.options.forEach((vitem) => {
												if (citem.optionIds[0] === vitem.id && citem
													.voteWay === "AGENT_ALL") {
													vitem.isFlag = true;
													isFinish = true
												}
											});
										}
									});
								});
								if (isFinish) {
									this.isVoteRecord = true;
									this.finishVote();
								} else {
									this.finishVotes();
								}
							}
						} else {
							if (this.status == 0) {
								this.btnLoading = false;
								this.voteText = '表决已结束';
								this.isVote = true;
							}
						}
						if (this.voteInfo.voteType == 'SINGLE_CHOICE' && this.remarkList.length == 0) {
							for (let i in this.voteInfo.groups) {
								if (this.voteInfo.groups[i].options != undefined) {
									console.log("ji")
									this.remarkList.push({
										id: '',
										name: ''
									})
								}
							}
						}

						console.log("remarkList", this.remarkList)
					})
				// .catch((err) => {
				// 	this.loading = false;
				// 	// console.log('err2', err)
				// 	this.$message.error('组别获取失败');
				// });
			},
			finishVotes() {
				let count = 0;
				console.log("groupingList", this.groupingList)
				for (let i = 0; i < this.groupingList.length; i++) {
					if (this.groupingList[i].voteUsers.length == '0') {
						count++;
					}
				}
				console.log("this.groupingList.length == count", this.groupingList.length == count)
				if (this.groupingList.length == count) {
					this.finishVote();
				} else {
					this.voteText = "立即表决";
					this.isVote = false;
					this.loading = false;
				}
			},
			closeVote() {
				this.keyword = '';
				this.selectList = [];
				this.creatorUserList = [];
				this.creatorUserLists = [];
				this.$emit('close');
			}
		}
	};
</script>
<style scoped lang="scss">
	.buttonnoen:focus,
	.buttonnoen:hover,
	.buttonnoen:active {
		outline: none;
		box-shadow: none;
		background-color: #FFFFFFF;
		border: 1px solid #dcdfe6 !important;
		color: #606266 !important;
	}

	.vote-name_ml {
		font-size: 14px;
		font-family: Source Han Sans CN-Medium, Source Han Sans CN;
		font-weight: bold;
		color: #282F36;
		line-height: 17px;
	}

	.vote-content_ml {
		font-size: 14px;
		font-family: Source Han Sans CN-Regular, Source Han Sans CN;
		font-weight: 400;
		color: #74798C;
		line-height: 17px;
	}

	.unfinished {
		width: 50%;
		overflow-y: scroll;
		height: 330px;
		position: relative;
	}

	.unfinished_li {
		margin-bottom: 17px;
	}

	.unfinished_title {
		font-size: 14px;
		font-family: Source Han Sans CN-Medium, Source Han Sans CN;
		font-weight: bold;
		color: #282F36;
		line-height: 22px;
	}

	.unfinished_content {
		font-size: 12px;
		font-family: Source Han Sans CN-Regular, Source Han Sans CN;
		font-weight: 400;
		color: #A6A6A6;
		line-height: 22px;
	}

	.unfinished_option {
		width: 120px;
		height: 36px;
		border: 1px solid #E5E5E5;
		font-size: 14px;
		font-family: Source Han Sans CN-Regular, Source Han Sans CN;
		font-weight: 400;
		color: #74798C;
		line-height: 20px;
		margin-bottom: 10px;
		border-radius: 3px;
	}

	.completed_option {
		width: 120px;
		height: 36px;
		border: 1px solid #8EDEB2;
		font-size: 14px;
		font-family: Source Han Sans CN-Regular, Source Han Sans CN;
		font-weight: 400;
		color: #009944;
		line-height: 20px;
		margin-bottom: 10px;
		border-radius: 3px;
	}

	.reminder {
		margin-top: 20px;
		font-size: 14px;
		font-family: Source Han Sans CN-Regular, Source Han Sans CN;
		font-weight: 400;
		color: #74798C;
		line-height: 20px;
	}

	.el-table ::v-deep .is-leaf {
		background: #fafbfd;
		color: rgba(25, 30, 36, 0.6);

		// color: #fff;
	}

	.box-card {
		padding-bottom: 20px;

		.btn {
			margin-top: 50px;
			text-align: center;

			.disabled {
				background: #d2cece;
				border: 1px solid #d2cece;
			}
		}

		.vote {
			.menu {
				margin-bottom: 30px;
			}

			.vote-name {
				list-style: none;
				margin-bottom: 20px;


				h3 {
					display: flex;
					justify-content: flex-start;
					align-items: center;

					i {
						color: #c22929;
						font-size: 25px;
					}

					.sign {
						color: #c22929;
						font-size: 16px;
						margin-left: 15px;
						letter-spacing: 2px;
					}
				}

				p {
					line-height: 30px;
					text-indent: 1.5em;
				}
			}
		}

		.vote-ul {
			padding-left: 20px;
			margin-top: 15px;
			display: flex;
			justify-content: flex-start;
			align-items: center;
			flex-wrap: wrap;


			.vote-li {
				list-style: none;
				padding: 5px 20px;
				margin-right: 20px;
				border: 1px solid #E5E5E5;
				font-size: 14px;
				font-family: Source Han Sans CN-Regular, Source Han Sans CN;
				font-weight: 400;
				color: #74798C;
				line-height: 20px;
				border-radius: 3px;
				margin-bottom: 15px;

				&.active {
					border: 1px solid #B2C7FF;
					color: #2766FF;
					background: #EAF1FF;

				}

				&:hover {
					cursor: pointer;
				}
			}
		}

		.vote-list {
			padding-left: 20px;
			margin-top: 15px;

			.vote-li {
				display: inline-block;
				margin-bottom: 10px;
				list-style: none;
				padding: 5px 20px;
				margin-right: 20px;
				border: 2px solid #d2cece;

				&.active {
					border: 2px solid #c22929;
					color: #c22929;
				}

				&:hover {
					cursor: pointer;
				}
			}
		}
	}
</style>